export default {
    hero: {
        title: "Eve Mind",
        claim: "El Trade Copilot revolucionario",
        description: "Una plataforma para enviar, controlar, asegurar y pagar – impulsada por IA",
        ctaLogin: "Iniciar sesión",
        ctaContact: "Contáctanos",
    },
    cta: {
        headline: "COMERCIO GLOBAL: UNA INDUSTRIA DE $30T QUE TODAVÍA FUNCIONA CON EMAILS Y EXCEL.",
        subline: "Esto va a cambiar",
    },
    agents: {
        care: {
            title: "Eve Care",
            subtitle: "Agente de Atención al Cliente IA",
            description: "Un agente IA para atención al cliente consciente del contexto, entrenado con la información de tu cuenta. Comprende solicitudes, responde en tiempo real, actualiza a los clientes sobre el estado de los envíos, llama a transportistas externos y registra automáticamente todas las interacciones en el sistema. También puede negociar tarifas, reconociendo los márgenes disponibles para optimizar cada envío.",
            features: [
                "Responde a las solicitudes de los clientes en tiempo real",
                "Actualiza automáticamente a los clientes sobre el estado de los envíos",
                "Negocia tarifas y optimiza márgenes",
                "Registra automáticamente todas las interacciones",
            ],
        },
        track: {
            title: "Eve Track",
            subtitle: "Agente de Seguimiento en Tiempo Real",
            description: "Un agente IA que conecta datos satelitales, comunicaciones de transportistas y sistemas de gestión en tiempo real. Responde automáticamente a los clientes que solicitan actualizaciones, consulta datos GPS o llama al transportista o conductor para obtener su ubicación. Eve Track recopila, verifica y actualiza el estado de cada envío, creando visibilidad completa y generando notificaciones automáticas en caso de retrasos o anomalías. La atención al cliente ya no necesita 'buscar información': la recibe lista, confiable y en tiempo real.",
            features: [
                "Conecta datos satelitales y GPS en tiempo real",
                "Responde automáticamente a solicitudes de actualización de clientes",
                "Genera notificaciones para retrasos y anomalías",
                "Proporciona visibilidad completa de los envíos",
            ],
        },
        quote: {
            title: "Eve Quote",
            subtitle: "Agente de Automatización de Cotizaciones",
            description: "El agente IA que automatiza y gestiona todo el ciclo de vida de las cotizaciones, desde recibir la solicitud hasta el seguimiento con el cliente. Eve Quote lee e interpreta automáticamente las solicitudes entrantes, extrae datos clave y calcula la tarifa más adecuada en segundos usando tus listas de precios y reglas de precios. Genera una oferta profesional, lista para enviar, y continúa siguiendo la conversación: responde preguntas, maneja modificaciones o actualizaciones de la cotización y mantiene un historial de todas las interacciones. Archiva e indexa automáticamente cada cotización, haciendo simple encontrar ofertas anteriores con un clic sin tener que buscar en emails o hilos de conversación.",
            features: [
                "Calcula tarifas en segundos usando tus reglas de precios",
                "Genera ofertas profesionales listas para enviar",
                "Maneja modificaciones y actualizaciones automáticamente",
                "Archiva e indexa cada cotización para fácil recuperación",
            ],
        },
        read: {
            title: "Eve Read",
            subtitle: "Agente de Lectura de Documentos",
            description: "Lee e interpreta automáticamente cada documento, independientemente del formato. Extrae datos clave, los estructura y los envía directamente al TMS, señalando inmediatamente cualquier anomalía. Eve Read no solo lee: aprende cómo quieres que se organicen tus datos, y lo hace cada vez mejor.",
            features: [
                "Lee documentos en cualquier formato automáticamente",
                "Extrae y estructura datos clave instantáneamente",
                "Envía datos directamente a tu TMS",
                "Aprende tus preferencias de organización de datos",
            ],
        },
        plan: {
            title: "Eve Plan",
            subtitle: "Agente de Planificación de Rutas",
            description: "Analiza flujos de pedidos, disponibilidad de vehículos y restricciones operativas, sugiriendo el plan de viaje más eficiente para cada día. Cuando cambian las condiciones - un retraso, un nuevo pedido o una avería - el sistema recalcula las prioridades en tiempo real, proponiendo la solución óptima al gerente de logística para aprobación o modificación.",
            features: [
                "Sugiere los planes de viaje más eficientes diariamente",
                "Recalcula prioridades en tiempo real cuando cambian las condiciones",
                "Considera disponibilidad de vehículos y restricciones operativas",
                "Propone soluciones óptimas para aprobación del gerente",
            ],
        },
    },
    features: {
        label: "Características",
        title: "Agentes IA poderosos para transformar tus operaciones comerciales",
        description: "Cinco agentes inteligentes trabajando juntos para automatizar, optimizar y revolucionar tu flujo de trabajo logístico. Confiado por empresas visionarias en todo el mundo.",
    },
    footer: {
        contactTitle: "¿Listo para transformar tu logística?",
        contactDescription: "Ponte en contacto con nuestro equipo para saber más sobre Eve Mind.",
        contactButton: "Contáctanos",
        loginLink: "¿Ya tienes una cuenta?",
        loginButton: "Iniciar sesión",
    },
};

